/**
 * Portfolio-intent detection for the RendPleX AI Advisor.
 *
 * When a Pro user asks a portfolio-scoped question (e.g. "which property
 * is my weakest?"), the server prompt instructs the LLM to decline in one
 * sentence and offer Premium. We surface a matching tap-to-upgrade chip
 * beneath the reply so the upgrade path is one tap, not a paragraph.
 *
 * Pure text heuristic, EN + FR, case-insensitive. Words like "portfolio"
 * alone are strong signals; multi-word phrases catch subtler cases.
 */

const PATTERNS = [
  /\bportfolio\b/i,
  /\bportefeuille\b/i,
  /\bmy (properties|deals|assets)\b/i,
  /\bmes (propri[ée]t[ée]s|immeubles|actifs)\b/i,
  /\bweakest property/i,
  /\bstrongest property/i,
  /\bpropri[ée]t[ée] la plus (faible|vuln[ée]rable|forte|r[ée]siliente)/i,
  /\bacross (my )?properties\b/i,
  /\bentre mes propri[ée]t[ée]s\b/i,
  /\bportfolio (health|doctor|goals|resilience|vulnerability)/i,
  /\bsant[ée] (de mon )?portefeuille/i,
  /\bstress test\b/i,
  /\btest de r[ée]sistance\b/i,
  /\bportfolio-wide\b/i,
  /\b[àa] l['’]échelle du portefeuille\b/i,
];

export function detectPortfolioIntent(text) {
  if (!text) return false;
  return PATTERNS.some((re) => re.test(text));
}
